export const VALIDATION_REGEX_TIME =
  /^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/;
export const VALIDATION_REGEX_ZIP_CODE = /^\d{3}-\d{4}$/;
export const VALIDATION_REGEX_PHONE_NUMBER = /^\d{10,11}$/;
export const VALIDATION_REGEX_KATAKANA = /^[ァ-ヴー]+$/u;
